import React, { useState, useEffect, useContext, createContext } from "react";
import * as api from "./api";

export function login() {
  localStorage.setItem('redirect', window.location.href);
  window.location.href = `${process.env.GATSBY_MMC_API_URL}/connect/auth0`;
};

export function logout(e) {
  if (e && e.preventDefault) e.preventDefault();

  localStorage.removeItem('jwt');
  localStorage.setItem('redirect', window.location.href);
  
  window.location.href = `https://${process.env.GATSBY_AUTH0_DOMAIN}/v2/logout?` + new URLSearchParams({
    client_id: process.env.GATSBY_AUTH0_CLIENT_ID,
    returnTo: `${document.location.origin}/auth/auth0/callback`,
  });
};

export async function getJwt(accessToken) {
  const response = await fetch(`${process.env.GATSBY_MMC_API_URL}/auth/auth0/callback?access_token=${accessToken}`);
  const data = await response.json();

  localStorage.setItem('jwt', data.jwt);
};
